import { CheckCircle2, Phone, Clock } from "lucide-react";
import { PHONE, PHONE_HREF } from "@/data/site";
import { Seo } from "@/components/Seo";

export default function ThankYou() {
  return (
    <div data-testid="thank-you-page" className="bg-brand-subtle min-h-[70vh] flex items-center">
      <Seo title="Request Received | Central Air Depot" description="Your estimate request is in. A Central Air Depot specialist is reviewing your details and will call you shortly." noindex />
      <div className="max-w-2xl mx-auto px-4 py-16 sm:py-24 text-center">
        <CheckCircle2 className="w-16 h-16 text-brand mx-auto" />
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-zinc-500 mt-6">Request Received</p>
        <h1 data-testid="thank-you-headline" className="text-4xl sm:text-5xl tracking-tighter leading-none font-black text-brand-ink mt-3">
          Thank you — your estimate request is in.
        </h1>
        <p className="text-zinc-600 mt-5 leading-relaxed max-w-lg mx-auto">
          A Central Air Depot specialist is reviewing your photos and home details right now.
        </p>
        <div data-testid="thank-you-callback-note" className="bg-white border-l-4 border-brand border-y border-r border-zinc-200 rounded-sm p-5 mt-8 flex items-center gap-3 text-left">
          <Clock className="w-7 h-7 text-brand shrink-0" />
          <p className="text-sm text-brand-ink">
            <span className="font-heading font-bold">Expect a call within 24 hours</span> with your free, honest replacement estimate — no pressure, no obligation.
          </p>
        </div>
        <p className="text-sm text-zinc-600 mt-8">Need us urgently? 24/7 emergency booking. Call any time — our system takes your request, and a technician is dispatched after a $200 prepaid emergency booking fee, which is applied toward your repair.</p>
        <a href={PHONE_HREF} data-testid="thank-you-phone-btn"
          className="inline-flex items-center gap-2 mt-3 bg-brand-red hover:bg-[#B02222] text-white font-bold px-8 py-4 rounded-sm transition-colors duration-200">
          <Phone className="w-5 h-5" /> Call {PHONE}
        </a>
      </div>
    </div>
  );
}
